// Fragment "tax receipts (B75)" — jurisdiction preset picker (TaxAdmin.jsx), the
// tax-category field embedded in every offering editor (TaxCategoryField.jsx), and the
// receipt column/actions on the Stripe transactions table (StripeTransactions.jsx).
// Fusionné dans ./index.js.
export default {
  fr: {
    // TaxAdmin.jsx — carte "juridiction fiscale"
    "tax.profile.title": "Votre juridiction fiscale",
    "tax.profile.country": "Pays",
    "tax.profile.region": "Province / État",
    "tax.profile.countryPh": "Sélectionner un pays",
    "tax.profile.regionPh": "Sélectionner une région",
    "tax.profile.custom": "Autre pays — configurez les taxes manuellement ci-dessous",
    "tax.profile.legalName": "Raison sociale",
    "tax.profile.address": "Adresse",
    "tax.profile.regNumbers": "Numéros d'enregistrement",

    // TaxCategoryField.jsx — champ intégré aux éditeurs d'offres (services, cours, produits…)
    "taxcat.label": "Catégorie fiscale",
    "taxcat.standard": "Taxable (standard)",
    "taxcat.exempt": "Exonéré",
    "taxcat.citationLabel": "Référence de l'exonération",
    "taxcat.citationPh": "Ex. article de loi ou motif d'exonération",
    "taxcat.sacLabel": "Code SAC (TPS/TVH Inde)",
    "taxcat.sacPh": "Ex. 999799",

    // StripeTransactions.jsx — colonne et actions reçu fiscal
    "stx.colReceipt": "Reçu",
    "stx.viewReceipt": "Voir le reçu fiscal",
    "stx.resendReceipt": "Renvoyer le reçu par courriel",
    "stx.receiptResent": "Reçu renvoyé à {email}",
    "stx.receiptResendError": "Échec de l'envoi du reçu.",
  },
  en: {
    // TaxAdmin.jsx — "tax jurisdiction" card
    "tax.profile.title": "Your tax jurisdiction",
    "tax.profile.country": "Country",
    "tax.profile.region": "Province / State",
    "tax.profile.countryPh": "Select a country",
    "tax.profile.regionPh": "Select a region",
    "tax.profile.custom": "Other country — configure tax lines manually below",
    "tax.profile.legalName": "Legal name",
    "tax.profile.address": "Address",
    "tax.profile.regNumbers": "Registration numbers",

    // TaxCategoryField.jsx — field embedded in every offering editor (services, courses, products…)
    "taxcat.label": "Tax category",
    "taxcat.standard": "Taxable (standard)",
    "taxcat.exempt": "Exempt",
    "taxcat.citationLabel": "Exemption citation",
    "taxcat.citationPh": "E.g. statute reference or reason for exemption",
    "taxcat.sacLabel": "SAC code (India GST)",
    "taxcat.sacPh": "E.g. 999799",

    // StripeTransactions.jsx — receipt column and actions
    "stx.colReceipt": "Receipt",
    "stx.viewReceipt": "View tax receipt",
    "stx.resendReceipt": "Resend receipt email",
    "stx.receiptResent": "Receipt resent to {email}",
    "stx.receiptResendError": "Failed to resend the receipt.",
  },
  es: {
    // TaxAdmin.jsx — tarjeta "jurisdicción fiscal"
    "tax.profile.title": "Tu jurisdicción fiscal",
    "tax.profile.country": "País",
    "tax.profile.region": "Provincia / Estado",
    "tax.profile.countryPh": "Selecciona un país",
    "tax.profile.regionPh": "Selecciona una región",
    "tax.profile.custom": "Otro país — configura los impuestos manualmente abajo",
    "tax.profile.legalName": "Razón social",
    "tax.profile.address": "Dirección",
    "tax.profile.regNumbers": "Números de registro",

    // TaxCategoryField.jsx — campo incluido en cada editor de oferta (servicios, cursos, productos…)
    "taxcat.label": "Categoría fiscal",
    "taxcat.standard": "Gravable (estándar)",
    "taxcat.exempt": "Exento",
    "taxcat.citationLabel": "Referencia de la exención",
    "taxcat.citationPh": "Ej. artículo de ley o motivo de la exención",
    "taxcat.sacLabel": "Código SAC (GST de India)",
    "taxcat.sacPh": "Ej. 999799",

    // StripeTransactions.jsx — columna y acciones de recibo fiscal
    "stx.colReceipt": "Recibo",
    "stx.viewReceipt": "Ver recibo fiscal",
    "stx.resendReceipt": "Reenviar recibo por correo",
    "stx.receiptResent": "Recibo reenviado a {email}",
    "stx.receiptResendError": "No se pudo reenviar el recibo.",
  },
};
